const KEY = 'pinweelo-player-prefs'

export const defaultPlayerPrefs = {
  speed: 1,
  autoplay: true,
  quality: 'auto',
  captions: 'off'
}

export const readPlayerPrefs = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || '{}')
    return { ...defaultPlayerPrefs, ...raw }
  } catch (err) {
    return { ...defaultPlayerPrefs }
  }
}

export const writePlayerPrefs = (next) => {
  const prefs = { ...readPlayerPrefs(), ...next }
  localStorage.setItem(KEY, JSON.stringify(prefs))
  return prefs
}

export const captionLines = (text) => String(text || '')
  .replace(/\s+/g, ' ')
  .trim()
  .split(/(?<=[.!?])\s+/)
  .map(line => line.trim())
  .filter(Boolean)

export const buildAutoCues = (text, duration) => {
  const lines = captionLines(text)
  const total = Math.max(1, Number(duration) || 1)
  if (!lines.length) return []
  const slice = total / lines.length
  return lines.map((line, index) => ({
    start: index * slice,
    end: index === lines.length - 1 ? total : (index + 1) * slice,
    text: line
  }))
}

export const cueAtTime = (cues, time) => {
  const now = Number(time) || 0
  return cues.find(cue => now >= cue.start && now < cue.end) || null
}
